import { selectAppConfig } from "./selectAppConfig";

export const selectTheme = (state) => selectAppConfig(state).theme;
